import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./CCMDashboard.module.css";
import PendingExtensionRequests from "./PendingExtensionRequests";
import NewBusiness from "./NewBusiness";
import RatesStatus from "./RatesStatus";
import BookedInterest from "./BookedInterest";
import MonthlyExtensionCount from "./MonthlyExtensionCount";
import AutoApprovalRate from "./AutoApprovalRate";
import DealerTrendsTable from "./DealerTrendsTable";
import PageLoader from "../../../common/PageLoader";
import NotificationBanner from "../NotificationBanner";
import { fetchCcmDashboardData } from "../../../store/slices/dashboard";

const CCMDashboard = () => {
  const dispatch = useDispatch();
  const { extensionRequests, newBusiness, rateStatus, bookedInterest, loading, error } = useSelector(
    (state) => state.ccmDashboard
  );

  useEffect(() => {
    dispatch(fetchCcmDashboardData());
  }, [dispatch]);

  return (
    <div className={styles.dashboardContainer}>
      {loading && <PageLoader />}
      <h1 className={styles.dashboardTitle}>Dashboard</h1>
      
      <NotificationBanner />

      {error && (
        <div className={styles.errorBanner}>
          {error}
        </div>
      )}
      <div className={styles.topRow}>
        <div className={styles.cardWrapper}>
          <PendingExtensionRequests 
            data={extensionRequests}
          />
        </div>
        <div className={styles.cardWrapper}>
          <NewBusiness 
            data={newBusiness}
          />
        </div>
        <div className={styles.cardWrapper}>
          <RatesStatus 
            data={rateStatus}
          />
        </div>
        <div className={styles.cardWrapper}>
          <BookedInterest 
            data={bookedInterest}
          />
        </div>
      </div>
      <div className={styles.middleRow}>
        <div className={styles.chartCardLarge}>
          <MonthlyExtensionCount />
        </div>
        <div className={styles.chartCardSmall}>
          <AutoApprovalRate isAdmin={false} />
        </div>
      </div>
      <div className={styles.bottomRow}>
        <DealerTrendsTable />
      </div>

    </div>
  );
};

export default CCMDashboard;
